import app from 'flarum/forum/app';
export function apiUrl(path) {
  return app.forum.attribute('apiUrl') + path;
}
export function formatPrice(price) {
  return (app.forum.attribute('shopCurrency') || '$') + Number(price).toFixed(2);
}
export function fetchProducts(ids) {
  if (!ids.length) return Promise.resolve([]);
  return app.request({
    method: 'GET',
    url: apiUrl('/shop/products?ids=' + ids.join(','))
  });
}

/** The cart lives in localStorage, so it survives reloads and logging in. */
const CART_KEY = 'abdulrehman-shop.cart';
function readCart() {
  try {
    const items = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
    return Array.isArray(items) ? items : [];
  } catch {
    return [];
  }
}
function writeCart(items) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  } catch {
    // Storage blocked: the cart only lasts for this page view.
  }
}
export const cart = {
  items: readCart,
  count() {
    return readCart().reduce((count, item) => count + item.quantity, 0);
  },
  quantityOf(id) {
    return readCart().find(item => item.id === id)?.quantity ?? 0;
  },
  add(product) {
    const items = readCart();
    const existing = items.find(item => item.id === product.id);
    if (existing) {
      existing.quantity = Math.min(existing.quantity + 1, 100);
    } else {
      items.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image_url: product.image_url,
        quantity: 1
      });
    }
    writeCart(items);
  },
  setQuantity(id, quantity) {
    writeCart(readCart().map(item => item.id === id ? {
      ...item,
      quantity: Math.max(1, Math.min(quantity, 100))
    } : item));
  },
  remove(id) {
    writeCart(readCart().filter(item => item.id !== id));
  },
  replace(items) {
    writeCart(items);
  },
  clear() {
    writeCart([]);
  }
};